module.exports = __webpack_public_path__ + "img/anejo-7-cantidad-de-anos-en-sr.f3b53f95.svg";